import { Cookies } from 'react-cookie';

import { SRBMDetailData } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getSRBMDetail = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/trap/srbm/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as SRBMDetailData;
};
